import { Box, Fade, Link, Slide } from "@mui/material";
import styles from './index.module.css'
import { useEffect, useState } from "react";

const ThankYou = ({
  handleAnotherLinkClick
}) => {

  const [applySlideAnim, toggleApplySlideAnim] = useState(false)
  const [applyTextAnim, toggleApplyTextAnim] = useState(false)
  const [applyFadeAnim, toggleApplyFadeAnim] = useState(false)
  const [applyAnotherRespAnim, toggleApplyAnotherRespAnim] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      toggleApplySlideAnim(true)
    }, 300);
    setTimeout(() => {
      toggleApplyTextAnim(true)
    }, 800);
    setTimeout(() => {
      toggleApplyFadeAnim(true)
    }, 1400);
    setTimeout(() => {
      toggleApplyAnotherRespAnim(true)
    }, 1600);
  }, [])

  return (
    <Box className={`h-full flex items-center justify-center flex-col `}>

      <Slide direction="down" in={applySlideAnim} mountOnEnter unmountOnExit>
        <Box className={`${styles['upper']} w-full h-1/2 relative isolate bg-[color] flex items-end justify-center rounded-tr-[var(--border-radius)] rounded-tl-[var(--border-radius)] `}>
          <Box className={`${styles['bold']} text-[#fff]`}>

            <Slide direction="up" in={applyTextAnim} mountOnEnter unmountOnExit>
              <Box className={`${styles['blue-slider-parent']} ${styles['first']}`}>
                Thank
              </Box>
            </Slide>

          </Box>
        </Box>
      </Slide>
      
      <Slide direction="up" in={applySlideAnim} mountOnEnter unmountOnExit>
        <Box className={`${styles['lower']} w-full h-1/2 relative -top-[1px] text-center isolate bg-[color] flex items-baseline justify-center rounded-br-[var(--border-radius)] rounded-bl-[var(--border-radius)] `}>
          <Box className={`${styles['bold']} ${styles['content-parent']} h-full text-[#fff]`}>

            <Slide direction="down" in={applyTextAnim} mountOnEnter unmountOnExit>
              <Box className={`${styles['blue-slider-parent']} ${styles['second']}`}>
                You !
              </Box>
            </Slide>

            <Fade in={applyFadeAnim}>
              <Box className={`${styles['get-back']} mt-2 `}>
                We will get back to you soon
              </Box>

            </Fade>

            <Fade in={applyAnotherRespAnim}>
              <Link className={`${styles['another']}`}
                onClick={() => handleAnotherLinkClick()}
              >
                Submit another response
              </Link>
            </Fade>

          </Box>
        </Box>
      </Slide>
    </Box>
  );
}

export default ThankYou;